import { PropsWithChildren, useMemo, useState } from 'react';
import { IntlProvider } from 'react-intl';
import en from './locales/en.json';
import th from './locales/th.json';
import zh from './locales/zh.json';
import ru from './locales/ru.json';
import ko from './locales/ko.json';
import ja from './locales/ja.json';

const messagesMap = { en, th, zh, ru, ko, ja }; 
const DEFAULT_LOCALE = (import.meta.env.VITE_DEFAULT_LOCALE || 'en') as 'en' | 'th' | 'zh' | 'ru' | 'ko' | 'ja';

export function IntlProviderWrapper({ children }: PropsWithChildren) {
  const [locale, setLocale] = useState<'en' | 'th' | 'zh' | 'ru' | 'ko' | 'ja'>(() => {
    const saved = localStorage.getItem('locale');
    if (saved === 'en' || saved === 'th' || saved === 'zh' || saved === 'ru' || saved === 'ko' || saved === 'ja') return saved;
    return DEFAULT_LOCALE;
  });
  (window as any).__setLocale = (l: 'en' | 'th' | 'zh' | 'ru' | 'ko' | 'ja') => { setLocale(l); localStorage.setItem('locale', l); };
  const messages = useMemo(() => (messagesMap[locale]), [locale]);
  return (<IntlProvider locale={locale} messages={messages}>{children}</IntlProvider>);
}
